<template>
  <div class="row">
    <div class="col-12">
      <div class="m-portlet">

        <div class="m-portlet__head">
          <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                Top managers
              </h3>
            </div>
          </div>
        </div>

        <div class="m-portlet__body">
          <loader v-if="loading"></loader>
          <div v-else>
            <div v-if="managers.length !== 0">

              <div class="row">
                <div class="col-9">

                  <div class="row pb-1 font-weight-bold mb-4">
                    <div class="col-3">
                      Manager
                    </div>
                    <div class="col-3">
                      Booked hrs
                    </div>
                    <div class="col-1">
                      Projects
                    </div>
                    <div class="col-1">
                      Tasks
                    </div>
                    <div class="col-3">
                      Compared total
                    </div>
                    <div class="col-1">
                      %
                    </div>
                  </div>

                  <div class="row" v-for="manager in managers">
                    <div class="col-12 light-hover py-2">
                      <div class="row">
                        <div class="col-3 align-self-center">
                          <span class="m-badge m-badge--dot mr-3" :style="{ background: manager.color }"></span>
                          {{ manager.name }}
                        </div>
                        <div class="col-3 client-name-col">
                          {{ manager.booked }}
                        </div>
                        <div class="col-1 client-name-col">
                          {{ manager.projectsCount }}
                        </div>
                        <div class="col-1 client-name-col">
                          {{ manager.tasksCount }}
                        </div>
                        <div class="col-3 client-name-col align-middle" style="vertical-align: middle;">
                          <div class="progress align-middle" style="width:100%; height: 4px; position: relative; top: 40%;">
                            <div class="progress-bar progress-bar-success" role="progressbar" v-bind:style="{ width: manager.percentToTotal + '%', background: manager.color }">
                            </div>
                          </div>
                        </div>
                        <div class="col-1 client-name-col">
                          {{ manager.percentToTotal }}
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="col-3">
                  <PieChart
                    :chart-data="chartData"
                    :options="chartOptions"></PieChart>
                </div>
              </div>
            </div>
            <div style="text-align: center" v-else>
              There are no tasks assigned within specified interval
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Colors from '../../components/colors'
  import PieChart from '../../components/charts/PieChart'

  export default {
    components: {
      PieChart
    },

    props: [
      'startDate',
      'endDate'
    ],

    data() {
      return {
        managers: [],
        loading: true
      }
    },

    watch: {
      startDate: function() {
        this.onRangeChanged()
      },
      endDate: function() {
        this.onRangeChanged()
      }
    },

    created() {
      this.getManagers()
    },

    methods: {
      onRangeChanged() {
        this.loading = true
        this.getManagers()
      },

      getManagers() {
        const data = {
          startDate: this.startDate,
          endDate: this.endDate
        }

        this.axios.get('reports/top/managers', { params: data })
          .then(res => {
            this.managers = res.data.data

            const colorsGenerator = new Colors()
            this.managers.forEach(manager => manager.color = colorsGenerator.getColor())

            this.loading = false
          })
          .catch(error => {})
      },
    },

    computed: {
      chartData() {
        return {
          labels: this.managers.map(manager => manager.name),
          datasets: [{
            data: this.managers.map(manager => manager.percentToTotal),
            backgroundColor: this.managers.map(manager => manager.color),
            label: 'chart'
          }]
        }
      },
      chartOptions() {
        return {
          responsive: true,
          maintainAspectRatio: false,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const i = tooltipItem.index
                return data.labels[i] + ': ' + data.datasets[0].data[i] + '%'
              }
            }
          }
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/reports/TopManagers.vue